import { DirectDebitNavbar, PoweredBy, hostedPageStyle } from "./DirectDebitChrome";

const BANK_LOGOS = {
  "008": {
    src: "/assets/images/direct-debit/mandiri.png",
    mobile: { width: 52, height: 15.18 },
    desktop: { width: 130, height: 37.95 },
  },
  "009": {
    src: "/assets/images/direct-debit/bni.png",
    mobile: { width: 52, height: 15.07 },
    desktop: { width: 120, height: 34.78 },
  },
  "002": {
    src: "/assets/images/direct-debit/bri.png",
    mobile: { width: 51, height: 12.02 },
    desktop: { width: 127.5, height: 30.06 },
  },
};

const titleStyle = {
  margin: 0,
  fontSize: 18,
  fontWeight: 600,
  lineHeight: "28px",
  color: "#1E2635",
};

const nameStyle = {
  fontSize: 14,
  fontWeight: 500,
  lineHeight: "20px",
  color: "#1E2635",
};

const secureStyle = {
  margin: 0,
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  gap: 4,
  fontSize: 12,
  fontWeight: 400,
  lineHeight: "18px",
  color: "#505662",
};

const errorStyle = {
  margin: 0,
  fontSize: 12,
  lineHeight: "18px",
  color: "#B42318",
};

function badgeStyle(available) {
  return {
    flexShrink: 0,
    display: "inline-flex",
    alignItems: "center",
    height: 18,
    borderRadius: 999,
    fontSize: 12,
    fontWeight: 500,
    color: available ? "#01793B" : "#C0C2C6",
    background: available ? "rgba(1, 121, 59, 0.05)" : "#ECEDEE",
    border: available ? "1px solid #80BC9D" : "1px solid #E1E3E4",
  };
}

const layoutCss = `
  .dd-bank-main {
    width: 100%;
    max-width: 480px;
    margin: 0 auto;
    padding: 24px 16px 32px;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 16px;
    box-sizing: border-box;
  }
  .dd-bank-card {
    width: 100%;
    background: #FFFFFF;
    border-radius: 16px;
    padding: 16px;
    display: flex;
    flex-direction: column;
    gap: 16px;
    box-shadow: 0 4px 4px rgba(0, 0, 0, 0.05);
    box-sizing: border-box;
  }
  .dd-bank-title-stack {
    display: flex;
    flex-direction: column;
    gap: 8px;
    width: 100%;
  }
  .dd-bank-form {
    width: 100%;
    background: #F9FAFA;
    border-radius: 16px;
    padding: 16px;
    display: flex;
    flex-direction: column;
    gap: 8px;
    box-sizing: border-box;
  }
  .dd-bank-label {
    display: none;
    align-items: center;
    gap: 8px;
    height: 20px;
    font-size: 14px;
    font-weight: 500;
    line-height: 20px;
    color: #1E2635;
  }
  .dd-bank-list {
    display: flex;
    flex-direction: column;
    gap: 8px;
  }
  .dd-bank-btn {
    width: 100%;
    background: #FFFFFF;
    border: none;
    border-radius: 12px;
    padding: 12px;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    gap: 8px;
    box-sizing: border-box;
    font-family: inherit;
  }
  .dd-bank-identity {
    display: flex;
    align-items: center;
    gap: 8px;
    height: 35.2px;
    min-width: 0;
  }
  .dd-bank-logo-frame {
    width: 64.8px;
    height: 35.2px;
    flex-shrink: 0;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .dd-bank-logo-slot {
    position: relative;
    width: 52px;
    height: 22px;
    flex-shrink: 0;
    overflow: hidden;
  }
  .dd-bank-logo {
    position: absolute;
    left: 50%;
    top: 50%;
    width: var(--logo-mw);
    height: var(--logo-mh);
    transform: translate(-50%, -50%);
    display: block;
  }
  .dd-bank-badge {
    padding: 0 8px;
    line-height: 18px;
  }
  @media (min-width: 1024px) {
    .dd-bank-main {
      flex: 1 0 auto;
      justify-content: center;
      justify-content: safe center;
      max-width: none;
      min-height: calc(100vh - 64px);
      padding: 32px 16px;
    }
    .dd-bank-card {
      max-width: 800px;
      padding: 24px;
    }
    .dd-bank-title-stack {
      gap: 16px;
    }
    .dd-bank-form {
      border: 1px solid #E1E3E4;
      padding: 23px;
      gap: 24px;
    }
    .dd-bank-label {
      display: flex;
    }
    .dd-bank-list {
      flex-direction: row;
      align-items: stretch;
      gap: 16px;
    }
    .dd-bank-name {
      display: none;
    }
    .dd-bank-btn {
      flex: 1 1 0;
      min-width: 0;
      width: auto;
      height: 105px;
      padding: 12px 16px;
      flex-direction: column;
      justify-content: center;
    }
    .dd-bank-identity {
      height: auto;
      justify-content: center;
    }
    .dd-bank-logo-frame {
      width: auto;
      height: 55px;
    }
    .dd-bank-logo-slot {
      position: static;
      width: auto;
      height: 55px;
      overflow: visible;
      display: flex;
      align-items: center;
      justify-content: center;
    }
    .dd-bank-logo {
      position: static;
      left: auto;
      top: auto;
      width: var(--logo-dw);
      height: var(--logo-dh);
      transform: none;
      object-fit: contain;
    }
    .dd-bank-badge {
      box-sizing: border-box;
      padding: 0 7px;
      line-height: 16px;
    }
  }
`;

export default function BankPicker({ banks, submitting, error, onSelect, brandName, logoUrl }) {
  return (
    <div style={hostedPageStyle}>
      <style>{layoutCss}</style>
      <DirectDebitNavbar brandName={brandName} logoUrl={logoUrl} />

      <main className="dd-bank-main">
        <section className="dd-bank-card">
          <div className="dd-bank-title-stack">
            <h1 style={titleStyle}>Choose Payment Methods</h1>

            <div className="dd-bank-form">
              <div className="dd-bank-label">
                <img src="/assets/images/direct-debit/number.svg" alt="" width={20} height={20} style={{ width: 20, height: 20, display: "block" }} />
                Direct Debit
              </div>

              <div className="dd-bank-list">
                {banks.map((bank) => {
                  const logo = BANK_LOGOS[bank.bank_code];
                  const available = bank.available && !submitting;

                  return (
                    <button
                      key={bank.bank_code}
                      className="dd-bank-btn"
                      type="button"
                      disabled={!available}
                      onClick={() => available && onSelect(bank.bank_code)}
                      style={{ cursor: available ? "pointer" : "default" }}
                    >
                      <span className="dd-bank-identity">
                        <span className="dd-bank-logo-frame">
                          <span className="dd-bank-logo-slot">
                            {logo ? (
                              <img
                                className="dd-bank-logo"
                                src={logo.src}
                                alt=""
                                style={{
                                  "--logo-mw": `${logo.mobile.width}px`,
                                  "--logo-mh": `${logo.mobile.height}px`,
                                  "--logo-dw": `${logo.desktop.width}px`,
                                  "--logo-dh": `${logo.desktop.height}px`,
                                }}
                              />
                            ) : null}
                          </span>
                        </span>
                        <span className="dd-bank-name" style={nameStyle}>{bank.name}</span>
                      </span>
                      <span className="dd-bank-badge" style={badgeStyle(bank.available)}>
                        {bank.available ? "Available" : "Coming Soon"}
                      </span>
                    </button>
                  );
                })}
              </div>
            </div>
          </div>

          {error ? <p style={errorStyle}>{error}</p> : null}

          <p style={secureStyle}>
            <img src="/assets/images/direct-debit/lock-outline.svg" alt="" width={14} height={14} style={{ width: 14, height: 14, display: "block" }} />
            Your payment is secure and encrypted
          </p>
        </section>

        <PoweredBy />
      </main>
    </div>
  );
}
